import type { RankingInfo } from '@tanstack/match-sorter-utils'
import type { Row } from '@tanstack/react-table'
import type { SRT_Row, SRT_RowData } from '../types'

import { compareItems } from '@tanstack/match-sorter-utils'
import { sortingFns } from '@tanstack/react-table'

const fuzzy = <TData extends SRT_RowData>(
	rowA: Row<TData>,
	rowB: Row<TData>,
	columnId: string
) => {
	let dir = 0
	if (rowA.columnFiltersMeta[columnId]) {
		dir = compareItems(
			rowA.columnFiltersMeta[columnId] as RankingInfo,
			rowB.columnFiltersMeta[columnId] as RankingInfo
		)
	}
	// Provide a fallback for when the item ranks are equal

	return dir === 0
		? sortingFns.alphanumeric(rowA as Row<any>, rowB as Row<any>, columnId)
		: dir
}

export const SRT_SortingFns = {
	...sortingFns,
	fuzzy,
}

export const rankGlobalFuzzy = <TData extends SRT_RowData>(
	rowA: SRT_Row<TData>,
	rowB: SRT_Row<TData>
) =>
	Math.max(...Object.values(rowB.columnFiltersMeta).map((v: any) => v.rank)) -
	Math.max(...Object.values(rowA.columnFiltersMeta).map((v: any) => v.rank))
